export const CREDITS_PER = {
  EMAIL: 20,
};

export const PLANS = {
  FREE: {
    price: 0,
    benefits: [
      "AI PDF Processing + Web Scraping",
      "Experiment-ready Credit Amounts",
      "Private + Public sharing options",
    ],
    description: "Experiment with Chatsheet for free. Build scalable AI workflows in seconds.",
  },
  PLUS: {
    benefits: ["All AI Features", "Production-ready Credit Amounts", "Private + Public sharing options"],
    description: "Optimized for balanced accuracy and cost. Great for sales pros and marketers.",
    subtiers: [
      {
        label: "plus_tier_1_monthly",
        price: 19,
      },
      {
        label: "plus_tier_2_monthly",
        price: 38,
      },
      {
        label: "plus_tier_3_monthly",
        price: 57,
      },
      {
        label: "plus_tier_4_monthly",
        price: 76,
      },
      {
        label: "plus_tier_5_monthly",
        price: 114,
      },
    ],
  },
  TEAM: {
    benefits: [
      "All AI Features",
      "Volume Credits Savings",
      "Team-based Sharing",
      "Flexible Team Size ($29 / additional seat, up to 20 people)",
    ],
    description: "Built for teams. Seamless collaboration and volume-based savings.",
    subtiers: [
      {
        label: "team_tier_1_monthly",
        price: 145,
      },
      {
        label: "team_tier_2_monthly",
        price: 290,
      },
      {
        label: "team_tier_3_monthly",
        price: 580,
      },
      {
        label: "team_tier_4_monthly",
        price: 870,
      },
      {
        label: "team_tier_5_monthly",
        price: 1160,
      },
      {
        label: "team_tier_6_monthly",
        price: 1450,
      },
      {
        label: "team_tier_7_monthly",
        price: 1740,
      },
    ],
  },
  SCALE: {
    benefits: [
      "All AI Features",
      "Volume Credits Savings",
      "Team-based Sharing",
      "Large Team Capacity ($49 / additional seat, up to 250 people)",
    ],
    description: "Offers maximum scalability. Perfect solution for large teams.",
    subtiers: [
      {
        label: "scale_tier_1_monthly",
        price: 1997,
      },
      {
        label: "scale_tier_2_monthly",
        price: 6657,
      },
      {
        label: "scale_tier_3_monthly",
        price: 8876,
      },
      {
        label: "scale_tier_4_monthly",
        price: 11094,
      },
      {
        label: "scale_tier_5_monthly",
        price: 13313,
      },
      {
        label: "scale_tier_6_monthly",
        price: 15532,
      },
      {
        label: "scale_tier_7_monthly",
        price: 17751,
      },
      {
        label: "scale_tier_8_monthly",
        price: 19970,
      },
      {
        label: "scale_tier_9_monthly",
        price: 22189,
      },
      {
        label: "scale_tier_10_monthly",
        price: 24408,
      },
    ],
  },
};
